import { render, staticRenderFns } from "./OrderRequestsListView.vue?vue&type=template&id=708ea216"
import script from "./OrderRequestsListView.vue?vue&type=script&lang=js"
export * from "./OrderRequestsListView.vue?vue&type=script&lang=js"
import style0 from "./OrderRequestsListView.vue?vue&type=style&index=0&id=708ea216&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports